import { Button, Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

type Props = {
	headingKey?: TranslationKey;
	descriptionKey?: TranslationKey;
	buttonKey?: TranslationKey;
	onAction: () => void;
};

export const RecommendationsError: React.FC<Props> = ({
	headingKey = translationKey('corgi.start_a_petition.recommendations.error.unrecoverable.heading'),
	descriptionKey = translationKey('corgi.start_a_petition.recommendations.error.unrecoverable.description'),
	buttonKey = translationKey('corgi.start_a_petition.recommendations.error.unrecoverable.button'),
	onAction,
}) => {
	return (
		<div className="flex h-[calc(100dvh-60px)] items-center md:h-auto">
			<div
				className="container mx-auto flex max-w-[620px] flex-col items-center gap-8 px-4 py-12 text-center"
				data-testid="error-screen"
			>
				<div className="flex flex-col gap-4">
					<Text as="h1" variant="heading" size="x-large">
						<TypedTranslate value={headingKey} />
					</Text>
					<Text as="p" variant="body">
						<TypedTranslate value={descriptionKey} />
					</Text>
				</div>
				<Button
					className="mx-auto w-full md:w-auto"
					variant="primary"
					size="large"
					data-qa="primary-action-link"
					onClick={onAction}
				>
					<TypedTranslate value={buttonKey} />
				</Button>
			</div>
		</div>
	);
};
